(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kupfer-product-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kupfer-fit-detail')) {
    customElements.define('kupfer-fit-detail', class extends HTMLElement {
      connectedCallback() {
        const lines = [...this.querySelectorAll('span')];
        if (!lines.length) return;
        const setStyle = (property, value) => lines.forEach(line => { line.style[property] = value; });
        const widest = () => Math.max(...lines.map(line => line.getBoundingClientRect().width));
        setStyle('display', 'inline-block');
        setStyle('overflowWrap', 'anywhere');
        setStyle('whiteSpace', 'nowrap');
        this.fit = () => {
          if (!this.isConnected) return;
          const available = this.parentElement.clientWidth;
          if (!available) return;
          const maximum = parseFloat(getComputedStyle(this.parentElement).fontSize);
          const minimum = Math.min(maximum, 13.5);
          let lower = minimum;
          let upper = maximum;
          setStyle('whiteSpace', 'nowrap');
          setStyle('maxWidth', 'none');
          setStyle('fontSize', `${maximum}px`);
          if (widest() <= available) return;
          setStyle('fontSize', `${minimum}px`);
          if (widest() > available) {
            setStyle('whiteSpace', 'normal');
            setStyle('maxWidth', '100%');
            setStyle('fontSize', `${maximum}px`);
            return;
          }
          // Measure the actual loaded font rather than estimating character widths.
          for (let step = 0; step < 12; step++) {
            const size = (lower + upper) / 2;
            setStyle('fontSize', `${size}px`);
            if (widest() <= available - 0.5) lower = size;
            else upper = size;
          }
          setStyle('fontSize', `${lower}px`);
        };
        this.observer = new ResizeObserver(this.fit);
        this.observer.observe(this.parentElement);
        document.fonts.ready.then(this.fit);
        this.fit();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
